import { useEffect } from "react";

/**
 * Scroll reveal observer — adds `.in-view` to elements with [data-reveal] / [data-reveal-fade]
 * when they enter the viewport. Includes a 2s safety fallback.
 */
export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(
      "[data-reveal], [data-reveal-fade]"
    );

    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.95) {
        el.classList.add("in-view");
      }
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -5% 0px" }
    );

    els.forEach((el) => {
      if (!el.classList.contains("in-view")) io.observe(el);
    });

    const fallback = setTimeout(() => {
      document
        .querySelectorAll(
          "[data-reveal]:not(.in-view), [data-reveal-fade]:not(.in-view)"
        )
        .forEach((el) => el.classList.add("in-view"));
    }, 2000);

    return () => {
      io.disconnect();
      clearTimeout(fallback);
    };
  }, []);
}
